import { DefaultError, useMutation } from '@tanstack/react-query';
import { updateGoalGroupingLifeAreaGoalOrder } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const useUpdateGoalGroupingLifeAreaGoalOrderMutation = () =>
  useMutation<void, DefaultError, { lifeAreaId: ID; goalIds: ID[] }[]>({
    mutationFn: async (lifeAreaSorting) =>
      updateGoalGroupingLifeAreaGoalOrder(lifeAreaSorting),
  });
